import { Injectable, signal } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
    providedIn: "root",
})
export class SpinnerService {
    private readonly loading = signal<boolean>(false);
    readonly isLoading = this.loading.asReadonly();

    show() {
        this.loading.set(true);
    }

    hide() {
        this.loading.set(false);
    }
}
